import { Dimension } from '@src/models/filters';

import instance from './common';
import http from './http';

const mockData: Dimension[] = [
  {
    dimension_name: 'asset-name',
    display_name: 'Asset Name',
    dimension_type: 'Content Information',
  },
  {
    dimension_name: 'content-category',
    display_name: 'Content Category',
    dimension_type: 'Content Information',
  },
  {
    dimension_name: 'device-marketing-name',
    display_name: 'Device Marketing Name',
    dimension_type: 'Device Information',
  },
  {
    dimension_name: 'device-name',
    display_name: 'Device Name',
    dimension_type: 'Device Information',
  },
];

export function getMeta(): Dimension[] {
  // return http.http.get('/v1/dimensions');
  return mockData;
}

export function getAutoCompletion(url, pattern) {
  let query;
  if (url.includes('?')) {
    query = `${url}&pattern=${pattern}`;
  } else {
    query = `${url}?pattern=${pattern}`;
  }
  return instance.get(query);
}

export function getFilters() {
  return http.get('/filters');
}

export function createFilter(data) {
  return instance.post('/filters', data);
}

export function updateFilter(fid, data) {
  return instance.post(`/filter/${fid}`, data);
}

// TODO: NOTE: backend API does not process rules
// for now, this is only used to load default "Filters"
export function searchFilter(query) {
  return instance.post('/filters/search', query);
}
